const buildProjectionScopeKey = (workId, begin, end) => JSON.stringify([
  String(workId ?? ""),
  begin.toISOString(),
  end.toISOString(),
]);

export const buildProjectionRequestKey = (level, parent) => (
  parent ? `${level}:${parent}` : level
);

const requestSessionId = Math.random().toString(36).slice(2) || "session";
let requestSequence = 0;

export const nextProjectionRequestId = () => {
  requestSequence += 1;
  return `${requestSessionId}:${requestSequence.toString(36)}`;
};

export default buildProjectionScopeKey;
